import { memo } from 'react'
import { OptionTemplate } from 'components/ui/selects/OptionTemplate'
import { SuggestionAddressItem } from 'schema'

import { IOptionProps } from './types'

import s from './SelectAddress.module.less'

// @ts-ignore
export const SelectAddressOption = memo<IOptionProps<SuggestionAddressItem>>(function SelectAddressOption({
  value,
  ...props
}) {
  return (
    // @ts-ignore
    <OptionTemplate {...props} isSelected={undefined} value={value}>
      <div className={s.optionLink} data-test-id="select--address--option">
        {value.value}
      </div>
    </OptionTemplate>
  )
})
